export const INFO = {
    MOVE_TO_FOLDER : "Move to folder",
    SHARE_SESSION : "Share session",
    DOWNLOAD : "Download",
    MAKE_A_COPY : "Make a copy",
    EDIT : "Edit",
    MOVE_TO_TRASH : "Move to trash"
}